// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e8cc2b8","478":"ee087686"}[chunkId] + ".chunk.js";
};